
const calculateDiscount = (original, discounted) => {
  const originalPrice = parseFloat(original);
  const discountedPrice = parseFloat(discounted);
  
  if (isNaN(originalPrice) || isNaN(discountedPrice) || originalPrice <= 0) {
    return 0;
  }
  
  const discount = ((originalPrice - discountedPrice) / originalPrice) * 100;
  return discount.toFixed(2);
};

export default calculateDiscount;